import { combineReducers } from 'redux';
import {
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILED,
} from '../actions';

function loading(state = false, action) {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
      return true;
    case CHANGE_PASSWORD_SUCCESS:
    case CHANGE_PASSWORD_FAILED:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case CHANGE_PASSWORD_REQUEST:
    case CHANGE_PASSWORD_SUCCESS:
      return null;
    case CHANGE_PASSWORD_FAILED:
      return action.error;
    default:
      return state;
  }
}

const changePassword = combineReducers({
  loading,
  error,
});

export default changePassword;
